import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import * as Icon from "react-feather";

import UserEdit from "./user-edit";
import UserList from "./user-list";

const UserContainer = class extends Component {
  render() {
    const { $user, $router, $group } = this.props.store;

    return (
      $user.sessionUser.isVerifiedMentor &&
      ($user.sessionUser.isVerifiedCreator ? (
        <React.Fragment>
          <header className="flex justify-between">
            <h2>Gebruikers</h2>
          </header>
          <div className="p-8">
            <UserList />

            {($router.mode === "new" || $router.mode === "edit") && (
              <M.Dialog
                open={Boolean($user.selected)}
                maxWidth="md"
                fullWidth
                handleClose={() => {
                  $user.detach($user.selected);
                  $router.push("/user");
                }}
              >
                <M.DialogTitle>
                  {$router.mode === "new" ? "Gebruiker toevoegen" : "Gebruiker aanpassen"}
                </M.DialogTitle>
                <M.DialogContent>
                  <UserEdit />
                </M.DialogContent>
                <M.DialogActions>
                  <M.Box display="flex" justifyContent="space-between" width="100%">
                    {$user.sessionUser.isVerifiedCreator && (
                      <M.Button
                        startIcon={<Icon.Trash size={18} color="#444" />}
                        onClick={e => $user.change("userToDelete", $user.selected)}
                      >
                        Verwijderen
                      </M.Button>
                    )}
                    <M.Box display="flex">
                      <M.Box marginRight={2}>
                        <M.Button
                          onClick={() => {
                            $user.selected && $user.detach($user.selected);
                            $router.push("/user");
                          }}
                          variant="outlined"
                        >
                          Annuleren
                        </M.Button>
                      </M.Box>
                      <M.Button
                        onClick={async () => {
                          await $user.selected.save();
                          $router.push("/user");
                        }}
                      >
                        {$router.mode === "new" ? "Voeg Toe" : "Bewaar"}
                      </M.Button>
                    </M.Box>
                  </M.Box>
                </M.DialogActions>
              </M.Dialog>
            )}

            <M.Dialog open={Boolean($user.userToDelete)}>
              <M.DialogTitle>Let op!</M.DialogTitle>
              <M.DialogContent>
                Deze gebruiker wordt verwijderd. De eventueel gekoppelde antwoorden blijven bestaan.
              </M.DialogContent>
              <M.DialogActions>
                <M.Button onClick={() => $user.detach($user.userToDelete)} variant="outlined">
                  Annuleren
                </M.Button>
                {$user.userToDelete && $user.userToDelete.groups && (
                  <M.Button
                    onClick={async () => {
                      if ($user.userToDelete.groups) {
                        const groupToDelete = $group.list.get($user.userToDelete.groups[0]);
                        await groupToDelete.delete();
                      }
                      await $user.userToDelete.delete();
                      $user.change("userToDelete", null);
                      $router.push("/user");
                    }}
                    className={"bg-red mr-2"}
                  >
                    verwijderen met groep
                  </M.Button>
                )}
                <M.Button
                  onClick={async () => {
                    await $user.userToDelete.delete();
                    $user.change("userToDelete", null);
                    $router.push("/user");
                  }}
                  className={"bg-red"}
                >
                  verwijderen
                </M.Button>
              </M.DialogActions>
            </M.Dialog>
          </div>
        </React.Fragment>
      ) : (
        $router.mode === "edit" && (
          <React.Fragment>
            <header className="flex justify-between">
              <h2>{$user.sessionUser.email}</h2>
            </header>
            <div className="p-8">
              <UserEdit />
            </div>
          </React.Fragment>
        )
      ))
    );
  }
};

export default inject("store")(observer(UserContainer));
